<template>
    <v-container fluid>
        <v-data-table
            item-key="id"
            :headers="headers"
            :items="itemsFiltered"
            class="elevation-0 brake-metals-finish-table"
            :mobile-breakpoint="0"
            :loading="loadingMain"
            disable-pagination
            hide-default-footer
            :height="$vuetify.breakpoint.mdAndDown ? '46vh' : '41vh'"
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">BRAKE METALS</h1>
                        <v-btn
                            rounded
                            color="primary"
                            class="mx-2"
                            :loading="loadingMain"
                            @click="openCreateItem"
                        >
                            <v-icon>mdi-plus</v-icon>
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'NEW' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`header.material`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="filterMaterial"
                    dense
                    prepend-icon="mdi-filter"
                    clearable
                />
            </template>
            <template v-slot:[`header.finishClass`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="filterFinishClass"
                    dense
                    prepend-icon="mdi-filter"
                    clearable
                />
            </template>
            <template v-slot:[`item.material`]="{ item }">
                <span class="finish-table-text">{{
                    item.material || '—'
                }}</span>
            </template>
            <template v-slot:[`item.thicknessMm`]="{ item }">
                <div class="text-right finish-table-num">
                    {{
                        item.thicknessMm == null || item.thicknessMm === ''
                            ? '—'
                            : formatThickness(item.thicknessMm)
                    }}
                </div>
            </template>
            <template v-slot:[`item.thicknessIn`]="{ item }">
                <div class="text-right finish-table-num">
                    {{
                        item.thicknessIn == null || item.thicknessIn === ''
                            ? '—'
                            : formatThickness(item.thicknessIn)
                    }}
                </div>
            </template>
            <template v-slot:[`item.finishClass`]="{ item }">
                <span class="finish-table-text">{{
                    item.finishClass || '—'
                }}</span>
            </template>
            <template v-slot:[`item.paintCost1Sides`]="{ item }">
                <div class="finish-table-price">
                    <span class="finish-table-currency">$</span>
                    <span class="finish-table-num">{{
                        formatUsdPerFt2(item.paintCost1Sides)
                    }}</span>
                </div>
            </template>
            <template v-slot:[`item.paintCost2Sides`]="{ item }">
                <div class="finish-table-price">
                    <span class="finish-table-currency">$</span>
                    <span class="finish-table-num">{{
                        formatUsdPerFt2(item.paintCost2Sides)
                    }}</span>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openEditItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small icon @click="openDeleteItem(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <v-data-table
            item-key="id"
            :headers="catalogHeaders"
            :items="catalogItemsFiltered"
            class="elevation-0 brake-metals-finish-catalog-table mt-6"
            :mobile-breakpoint="0"
            :loading="loadingCatalog"
            disable-pagination
            hide-default-footer
            :height="$vuetify.breakpoint.mdAndDown ? '34vh' : '28vh'"
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-3 pb-0 pb-3"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col
                        cols="12"
                        class="d-flex mb-n3 align-center flex-wrap"
                    >
                        <h2 class="mr-4">FINISH CLASS CATALOG</h2>
                        <input
                            ref="catalogXlsxInput"
                            type="file"
                            accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                            class="d-none"
                            @change="onCatalogXlsxSelected"
                        />
                        <v-btn
                            rounded
                            color="primary"
                            class="mx-2"
                            :loading="loadingCatalog"
                            @click="openCreateCatalogItem"
                        >
                            <v-icon>mdi-plus</v-icon>
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'NEW' }}
                        </v-btn>
                        <v-btn
                            rounded
                            outlined
                            color="primary"
                            class="mx-2"
                            :loading="loadingCatalog"
                            @click="triggerCatalogXlsxImport"
                        >
                            <v-icon>mdi-file-excel</v-icon>
                            {{
                                $vuetify.breakpoint.smAndDown
                                    ? ''
                                    : 'IMPORT XLSX'
                            }}
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`header.finish`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="filterCatalogFinish"
                    dense
                    prepend-icon="mdi-filter"
                    clearable
                />
            </template>
            <template v-slot:[`header.finishClass`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="filterCatalogFinishClass"
                    dense
                    prepend-icon="mdi-filter"
                    clearable
                />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openEditCatalogItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small icon @click="openDeleteCatalogItem(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <v-dialog
            v-model="openItemForm"
            :retain-focus="false"
            persistent
            width="640px"
        >
            <FinishFormBrakeMetal
                v-if="openItemForm"
                :create-form="createForm"
                :item="selectedItem"
                :original-item="originalItem"
                :setting="setting"
                :duplicate-row-keys="duplicateFinishRowKeys"
                :finish-class-options="finishClassSelectItems"
                @addItem="addItem"
                @replaceItem="replaceItem"
                @close="closeEditItem"
            />
        </v-dialog>
        <v-dialog
            v-model="openCatalogItemForm"
            :retain-focus="false"
            persistent
            width="560px"
        >
            <FinishFormBrakeMetalsCatalog
                v-if="openCatalogItemForm"
                :create-form="createCatalogForm"
                :item="selectedCatalogItem"
                :original-item="originalCatalogItem"
                :setting="setting"
                @addItem="addCatalogItem"
                @replaceItem="replaceCatalogItem"
                @close="closeCatalogItemForm"
            />
        </v-dialog>

        <v-dialog
            v-model="openDeleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card v-if="openDeleteWarning" :loading="loadingMain">
                <v-card-title class="text-h5">Delete Item</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this finish?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDeleteItem">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="error"
                        :loading="loadingMain"
                        @click="deleteItem"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="openCatalogDeleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card v-if="openCatalogDeleteWarning" :loading="loadingCatalog">
                <v-card-title class="text-h5">Delete Catalog Item</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this catalog option?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeDeleteCatalogItem"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="error"
                        :loading="loadingCatalog"
                        @click="deleteCatalogItem"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import * as XLSX from 'xlsx/xlsx.mjs'
import API from '@/services/api'
import FinishFormBrakeMetal from '@/components/Settings/Clients/FinishFormBrakeMetal.vue'
import FinishFormBrakeMetalsCatalog from '@/components/Settings/Clients/FinishFormBrakeMetalsCatalog.vue'
import { brakeMetalsFinishRowKey } from '@/constants/brakeMetalsFinishSettings.js'

export default {
    name: 'FinishBrakeMetals',
    components: {
        FinishFormBrakeMetal,
        FinishFormBrakeMetalsCatalog,
    },
    props: {
        setting: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        loadingMain: false,
        loadingCatalog: false,
        items: [],
        catalogItems: [],
        selectedItem: {},
        originalItem: {},
        selectedCatalogItem: {},
        originalCatalogItem: {},
        createForm: true,
        createCatalogForm: true,
        openItemForm: false,
        openCatalogItemForm: false,
        openDeleteWarning: false,
        openCatalogDeleteWarning: false,
        filterMaterial: '',
        filterFinishClass: '',
        filterCatalogFinish: '',
        filterCatalogFinishClass: '',
        headers: [
            {
                text: 'MATERIAL',
                value: 'material',
                sortable: false,
                align: 'center',
                width: '18%',
            },
            {
                text: 'THICKNESS (mm)',
                value: 'thicknessMm',
                sortable: false,
                align: 'center',
                width: '12%',
            },
            {
                text: 'THICKNESS (in)',
                value: 'thicknessIn',
                sortable: false,
                align: 'center',
                width: '12%',
            },
            {
                text: 'FINISH CLASS',
                value: 'finishClass',
                sortable: false,
                align: 'center',
                width: '28%',
            },
            {
                text: 'PV ONE SIDE USD/ft²',
                value: 'paintCost1Sides',
                sortable: false,
                align: 'center',
                width: '18%',
            },
            {
                text: 'PV TWO SIDES USD/ft²',
                value: 'paintCost2Sides',
                sortable: false,
                align: 'center',
                width: '18%',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                align: 'center',
                width: '6%',
            },
        ],
        catalogHeaders: [
            {
                text: 'FINISH',
                value: 'finish',
                sortable: false,
                width: '42%',
            },
            {
                text: 'FINISH CLASS',
                value: 'finishClass',
                sortable: false,
                width: '46%',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                align: 'center',
                width: '12%',
            },
        ],
    }),
    computed: {
        duplicateFinishRowKeys() {
            const skipId =
                this.openItemForm && !this.createForm && this.selectedItem.id
                    ? this.selectedItem.id
                    : null
            return this.items
                .filter(i => (skipId ? i.id !== skipId : true))
                .map(i => brakeMetalsFinishRowKey(i))
        },
        finishClassSelectItems() {
            const out = []
            const seen = new Set()
            this.catalogItems.forEach(i => {
                const value = String(i.finishClass || '').trim()
                if (!value || seen.has(value)) return
                seen.add(value)
                out.push(value)
            })
            return out.sort((a, b) => a.localeCompare(b))
        },
        itemsFiltered() {
            let rows = [...this.items]
            const qm = (this.filterMaterial || '').trim().toLowerCase()
            if (qm) {
                rows = rows.filter(i =>
                    String(i.material || '')
                        .toLowerCase()
                        .includes(qm)
                )
            }
            const qf = (this.filterFinishClass || '').trim().toLowerCase()
            if (qf) {
                rows = rows.filter(i =>
                    String(i.finishClass || '')
                        .toLowerCase()
                        .includes(qf)
                )
            }
            rows.sort((a, b) => {
                const ma = String(a.material || '')
                const mb = String(b.material || '')
                if (ma !== mb) return ma.localeCompare(mb)
                const ta = Number(a.thicknessMm)
                const tb = Number(b.thicknessMm)
                if (Number.isFinite(ta) && Number.isFinite(tb) && ta !== tb) {
                    return ta - tb
                }
                return String(a.finishClass || '').localeCompare(
                    String(b.finishClass || '')
                )
            })
            return rows
        },
        catalogItemsFiltered() {
            let rows = [...this.catalogItems]
            const qFinish = (this.filterCatalogFinish || '')
                .trim()
                .toLowerCase()
            if (qFinish) {
                rows = rows.filter(i =>
                    String(i.finish || '')
                        .toLowerCase()
                        .includes(qFinish)
                )
            }
            const qClass = (this.filterCatalogFinishClass || '')
                .trim()
                .toLowerCase()
            if (qClass) {
                rows = rows.filter(i =>
                    String(i.finishClass || '')
                        .toLowerCase()
                        .includes(qClass)
                )
            }
            return rows.sort((a, b) => {
                const fa = String(a.finish || '')
                const fb = String(b.finish || '')
                if (fa !== fb) return fa.localeCompare(fb)
                return String(a.finishClass || '').localeCompare(
                    String(b.finishClass || '')
                )
            })
        },
    },
    async mounted() {
        await Promise.all([this.loadItems(), this.loadCatalogItems()])
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async loadItems() {
            try {
                this.loadingMain = true
                this.items = await API.getAllFinishBrakeMetals(this.setting.id)
            } catch (error) {
                this.setErrorItems({
                    name: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loadingMain = false
            }
        },
        async loadCatalogItems() {
            try {
                this.loadingCatalog = true
                this.catalogItems = await API.getAllFinishBrakeMetalsCatalog(
                    this.setting.id
                )
            } catch (error) {
                this.setErrorItems({
                    name: `${this.$options.name}Catalog`,
                    message: error.message,
                })
            } finally {
                this.loadingCatalog = false
            }
        },
        formatThickness(n) {
            return new Intl.NumberFormat('es-ES', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(Number(n))
        },
        formatUsdPerFt2(number) {
            return new Intl.NumberFormat('es-ES', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 2,
            }).format(Number(number) || 0)
        },
        replaceItem(itemToUpdate) {
            const index = this.items.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.items.splice(index, 1, {
                    ...this.items[index],
                    ...itemToUpdate,
                })
            }
        },
        addItem(item) {
            this.items.push(item)
        },
        removeItem() {
            const index = this.items.findIndex(
                item => item.id == this.selectedItem.id
            )
            if (index >= 0) {
                this.items.splice(index, 1)
            }
        },
        async deleteItem() {
            try {
                this.loadingMain = true
                await API.deleteFinishBrakeMetals({
                    settingId: this.setting.id,
                    id: this.selectedItem.id,
                })
                this.removeItem()
                this.closeDeleteItem()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loadingMain = false
            }
        },
        closeDeleteItem() {
            this.selectedItem = {}
            this.openDeleteWarning = false
        },
        openDeleteItem(item) {
            this.selectedItem = _.cloneDeep(item)
            this.openDeleteWarning = true
        },
        closeEditItem() {
            this.createForm = true
            this.selectedItem = {}
            this.originalItem = {}
            this.openItemForm = false
        },
        openEditItem(item) {
            this.createForm = false
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.openItemForm = true
        },
        openCreateItem() {
            this.createForm = true
            this.selectedItem = {
                material: '',
                thicknessMm: null,
                finishClass: '',
                paintCost1Sides: 0,
                paintCost2Sides: 0,
                name: '',
            }
            this.originalItem = {}
            this.openItemForm = true
        },
        addCatalogItem(item) {
            this.catalogItems.push(item)
        },
        replaceCatalogItem(itemToUpdate) {
            const index = this.catalogItems.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.catalogItems.splice(index, 1, {
                    ...this.catalogItems[index],
                    ...itemToUpdate,
                })
            }
        },
        removeCatalogItem() {
            const index = this.catalogItems.findIndex(
                item => item.id == this.selectedCatalogItem.id
            )
            if (index >= 0) {
                this.catalogItems.splice(index, 1)
            }
        },
        openCreateCatalogItem() {
            this.createCatalogForm = true
            this.selectedCatalogItem = {
                finish: '',
                finishClass: '',
            }
            this.originalCatalogItem = {}
            this.openCatalogItemForm = true
        },
        openEditCatalogItem(item) {
            this.createCatalogForm = false
            this.selectedCatalogItem = _.cloneDeep(item)
            this.originalCatalogItem = _.cloneDeep(item)
            this.openCatalogItemForm = true
        },
        closeCatalogItemForm() {
            this.createCatalogForm = true
            this.selectedCatalogItem = {}
            this.originalCatalogItem = {}
            this.openCatalogItemForm = false
        },
        openDeleteCatalogItem(item) {
            this.selectedCatalogItem = _.cloneDeep(item)
            this.openCatalogDeleteWarning = true
        },
        closeDeleteCatalogItem() {
            this.selectedCatalogItem = {}
            this.openCatalogDeleteWarning = false
        },
        async deleteCatalogItem() {
            try {
                this.loadingCatalog = true
                await API.deleteFinishBrakeMetalsCatalog({
                    settingId: this.setting.id,
                    id: this.selectedCatalogItem.id,
                })
                this.removeCatalogItem()
                this.closeDeleteCatalogItem()
            } catch (error) {
                this.setErrorItems({
                    source: `${this.$options.name}Catalog`,
                    message: error.message,
                })
            } finally {
                this.loadingCatalog = false
            }
        },
        triggerCatalogXlsxImport() {
            this.$refs.catalogXlsxInput?.click()
        },
        normalizeCatalogXlsxHeader(cell) {
            return String(cell ?? '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, ' ')
        },
        findCatalogImportColumnIndices(headerRow) {
            const norm = (headerRow || []).map(h =>
                this.normalizeCatalogXlsxHeader(h)
            )
            const finishIdx = norm.findIndex(
                h => h === 'nombre' || h === 'name'
            )
            const finishClassIdx = norm.findIndex(
                h => h === 'finish class' || h === 'finishclass'
            )
            return { finishIdx, finishClassIdx }
        },
        async onCatalogXlsxSelected(event) {
            const input = event.target
            const file = input.files && input.files[0]
            input.value = ''
            if (!file) return
            if (!/\.(xlsx|xls)$/i.test(file.name)) {
                this.setErrorItems({
                    name: `${this.$options.name}Catalog`,
                    message: 'Solo se admiten archivos .xlsx o .xls',
                })
                return
            }
            try {
                const buf = await file.arrayBuffer()
                const wb = XLSX.read(buf, { type: 'array' })
                const ws = wb.Sheets[wb.SheetNames[0]]
                const rows = XLSX.utils.sheet_to_json(ws, {
                    header: 1,
                    defval: '',
                    raw: false,
                })
                if (!rows || !rows.length) {
                    this.setErrorItems({
                        name: `${this.$options.name}Catalog`,
                        message: 'El archivo no tiene datos',
                    })
                    return
                }
                const {
                    finishIdx,
                    finishClassIdx,
                } = this.findCatalogImportColumnIndices(rows[0])
                if (finishIdx < 0 || finishClassIdx < 0) {
                    this.setErrorItems({
                        name: `${this.$options.name}Catalog`,
                        message:
                            'La primera fila debe incluir las columnas "Nombre" o "Name" (finish) y "Finish Class" (finish class)',
                    })
                    return
                }
                const existing = new Set(
                    this.catalogItems.map(
                        i =>
                            `${String(i.finish || '')
                                .trim()
                                .toLowerCase()}||${String(i.finishClass || '')
                                .trim()
                                .toLowerCase()}`
                    )
                )
                const seenInFile = new Set()
                const pending = []
                for (let r = 1; r < rows.length; r++) {
                    const row = rows[r]
                    const finish = String(row[finishIdx] ?? '').trim()
                    const finishClass = String(row[finishClassIdx] ?? '').trim()
                    if (!finish && !finishClass) continue
                    if (!finish || !finishClass) continue
                    const key = `${finish.toLowerCase()}||${finishClass.toLowerCase()}`
                    if (seenInFile.has(key) || existing.has(key)) continue
                    seenInFile.add(key)
                    pending.push({ finish, finishClass })
                }
                if (!pending.length) {
                    this.setErrorItems({
                        name: `${this.$options.name}Catalog`,
                        message:
                            'No hay filas válidas nuevas (se omiten duplicados y filas incompletas)',
                    })
                    return
                }
                this.loadingCatalog = true
                let imported = 0
                const errors = []
                for (const p of pending) {
                    try {
                        const created = await API.createFinishBrakeMetalsCatalog(
                            {
                                settingId: this.setting.id,
                                finish: p.finish,
                                finishClass: p.finishClass,
                            }
                        )
                        this.catalogItems.push(created)
                        existing.add(
                            `${p.finish.toLowerCase()}||${p.finishClass.toLowerCase()}`
                        )
                        imported++
                    } catch (err) {
                        errors.push(`${p.finish}: ${err.message}`)
                    }
                }
                if (errors.length) {
                    const sample = errors.slice(0, 5).join('; ')
                    const errSuffix = errors.length > 5 ? '…' : ''
                    this.setErrorItems({
                        name: `${this.$options.name}Catalog`,
                        message: `Importados ${imported} de ${pending.length}. Errores: ${sample}${errSuffix}`,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    name: `${this.$options.name}Catalog`,
                    message: error.message || 'No se pudo leer el archivo',
                })
            } finally {
                this.loadingCatalog = false
            }
        },
    },
}
</script>

<style scoped>
.finish-table-text {
    font-size: 13px;
}
.finish-table-num {
    font-variant-numeric: tabular-nums;
    font-size: 13px;
}
.finish-table-price {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    width: 100%;
    padding-left: 4px;
    padding-right: 8px;
}
.finish-table-currency {
    font-weight: 500;
}
</style>

<style lang="css">
.brake-metals-finish-table.v-data-table,
.brake-metals-finish-catalog-table.v-data-table {
    border: 1px solid #eeeeee;
}
.brake-metals-finish-table thead,
.brake-metals-finish-catalog-table thead {
    background: #eeeeee;
    position: sticky;
    z-index: 2;
}
.brake-metals-finish-table .v-input .v-label,
.brake-metals-finish-catalog-table .v-input .v-label {
    font-size: 12px;
}
.brake-metals-finish-table .v-data-table-header th,
.brake-metals-finish-catalog-table .v-data-table-header th {
    background-color: #eeeeee !important;
}
.brake-metals-finish-table .v-data-table__wrapper {
    max-height: 41vh;
    overflow-y: auto;
}
@media (max-width: 1264px) {
    .brake-metals-finish-table .v-data-table__wrapper {
        max-height: 46vh;
    }
}
</style>
